module.exports = __webpack_public_path__ + "img/neat.d54e9721.png";